import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-wallet': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200c5 0 10 2.5 13 6.5 43.8 59.8 66.3 123.8 82.5 193.5h-103.5c-20-69.5-49.5-133-91.7-187.3-4-5.2 0-12.7 6.5-12.7h93.2zM157.1 112h108.7c74.8 103 131.2 230 143.2 368h-113.7c-8.2-133.5-69.7-260-138.2-368zM408.9 43.5c19 67.5 31.1 139 31.1 212.6 0 69.5-9.5 142.5-25.3 203-10.9-92.5-42.4-184.6-90.6-270.8-4.2-50.5-13.3-99.5-26.5-146-1.2-5.3 2.5-10.3 7.8-10.3h88.3c7 0 13.4 4.7 15.2 11.5z'
      }
    ]
  }
})
